import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRightIcon, TerminalIcon, UsersIcon } from 'lucide-react';
const StickyCtaBar = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero (approx 800px)
      if (window.scrollY > 800) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-1084">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed bottom-0 left-0 right-0 z-50 hidden md:flex justify-center pb-6 pointer-events-none" data-id="element-1085">
          <div className="bg-white/90 backdrop-blur-lg border border-gray-200 shadow-xl rounded-full px-6 py-3 flex items-center gap-4 pointer-events-auto" data-id="element-1086">
            <span className="text-sm font-medium text-gray-600" data-id="element-1087">
              Ready to build safe agents?
            </span>
            <div className="flex items-center gap-3" data-id="element-1088">
              <a href="/community" className="text-sm font-medium text-orange-500 hover:text-orange-600 transition-colors flex items-center gap-1" data-id="element-1089">
                <UsersIcon size={14} data-id="element-1090" />
                Community
              </a>
              <a href="https://cal.com/fluidn/30min" target="_blank" rel="noopener noreferrer" className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-1" data-id="element-1091">
                <TerminalIcon size={14} data-id="element-1092" />
                Docs
              </a>
              <a href="https://cal.com/fluidn/30min" target="_blank" rel="noopener noreferrer" className="bg-orange-500 text-white px-4 py-2 rounded-full text-sm font-semibold hover:bg-orange-600 transition-colors flex items-center gap-2 shadow-sm shadow-orange-500/20" data-id="element-1093">
                Get a demo
                <ArrowRightIcon size={14} data-id="element-1094" />
              </a>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
};
export default StickyCtaBar;